import Ie, { useMemo as B, useState as vr, useCallback as hr } from "react";
var se = { exports: {} }, U = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ye;
function pr() {
  if (ye)
    return U;
  ye = 1;
  var e = Ie, r = 60103;
  if (U.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    r = n("react.element"), U.Fragment = n("react.fragment");
  }
  var a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, u = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(l, v, _) {
    var R, w = {}, A = null, I = null;
    _ !== void 0 && (A = "" + _), v.key !== void 0 && (A = "" + v.key), v.ref !== void 0 && (I = v.ref);
    for (R in v)
      o.call(v, R) && !u.hasOwnProperty(R) && (w[R] = v[R]);
    if (l && l.defaultProps)
      for (R in v = l.defaultProps, v)
        w[R] === void 0 && (w[R] = v[R]);
    return { $$typeof: r, type: l, key: A, ref: I, props: w, _owner: a.current };
  }
  return U.jsx = f, U.jsxs = f, U;
}
var re = {};
/** @license React v16.14.0
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var we;
function gr() {
  return we || (we = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var r = Ie, n = 60103, a = 60106;
      e.Fragment = 60107;
      var o = 60108, u = 60114, f = 60109, l = 60110, v = 60112, _ = 60113, R = 60120, w = 60115, A = 60116, I = 60121, le = 60122, ce = 60117, de = 60129, ve = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var b = Symbol.for;
        n = b("react.element"), a = b("react.portal"), e.Fragment = b("react.fragment"), o = b("react.strict_mode"), u = b("react.profiler"), f = b("react.provider"), l = b("react.context"), v = b("react.forward_ref"), _ = b("react.suspense"), R = b("react.suspense_list"), w = b("react.memo"), A = b("react.lazy"), I = b("react.block"), le = b("react.server.block"), ce = b("react.fundamental"), b("react.scope"), b("react.opaque.id"), de = b("react.debug_trace_mode"), b("react.offscreen"), ve = b("react.legacy_hidden");
      }
      var he = typeof Symbol == "function" && Symbol.iterator, We = "@@iterator";
      function He(t) {
        if (t === null || typeof t != "object")
          return null;
        var i = he && t[he] || t[We];
        return typeof i == "function" ? i : null;
      }
      var L = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function y(t) {
        {
          for (var i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), c = 1; c < i; c++)
            s[c - 1] = arguments[c];
          Ve("error", t, s);
        }
      }
      function Ve(t, i, s) {
        {
          var c = L.ReactDebugCurrentFrame, p = "";
          if (k) {
            var g = j(k.type), h = k._owner;
            p += qe(g, k._source, h && j(h.type));
          }
          p += c.getStackAddendum(), p !== "" && (i += "%s", s = s.concat([p]));
          var d = s.map(function(E) {
            return "" + E;
          });
          d.unshift("Warning: " + i), Function.prototype.apply.call(console[t], console, d);
        }
      }
      var Be = !1;
      function Fe(t) {
        return !!(typeof t == "string" || typeof t == "function" || t === e.Fragment || t === u || t === de || t === o || t === _ || t === R || t === ve || Be || typeof t == "object" && t !== null && (t.$$typeof === A || t.$$typeof === w || t.$$typeof === f || t.$$typeof === l || t.$$typeof === v || t.$$typeof === ce || t.$$typeof === I || t[0] === le));
      }
      var J = /^(.*)[\\\/]/;
      function qe(t, i, s) {
        var c = "";
        if (i) {
          var p = i.fileName, g = p.replace(J, "");
          if (/^index\./.test(g)) {
            var h = p.match(J);
            if (h) {
              var d = h[1];
              if (d) {
                var E = d.replace(J, "");
                g = E + "/" + g;
              }
            }
          }
          c = " (at " + g + ":" + i.lineNumber + ")";
        } else
          s && (c = " (created by " + s + ")");
        return `
    in ` + (t || "Unknown") + c;
      }
      var ze = 1;
      function Je(t) {
        return t._status === ze ? t._result : null;
      }
      function Ke(t, i, s) {
        var c = i.displayName || i.name || "";
        return t.displayName || (c !== "" ? s + "(" + c + ")" : s);
      }
      function j(t) {
        if (t == null)
          return null;
        if (typeof t.tag == "number" && y("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof t == "function")
          return t.displayName || t.name || null;
        if (typeof t == "string")
          return t;
        switch (t) {
          case e.Fragment:
            return "Fragment";
          case a:
            return "Portal";
          case u:
            return "Profiler";
          case o:
            return "StrictMode";
          case _:
            return "Suspense";
          case R:
            return "SuspenseList";
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case l:
              return "Context.Consumer";
            case f:
              return "Context.Provider";
            case v:
              return Ke(t, t.render, "ForwardRef");
            case w:
              return j(t.type);
            case I:
              return j(t.render);
            case A: {
              var i = t, s = Je(i);
              if (s)
                return j(s);
              break;
            }
          }
        return null;
      }
      var pe = {};
      L.ReactDebugCurrentFrame;
      var k = null;
      function W(t) {
        k = t;
      }
      function Ge(t, i, s, c, p) {
        {
          var g = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var h in t)
            if (g(t, h)) {
              var d = void 0;
              try {
                if (typeof t[h] != "function") {
                  var E = Error((c || "React class") + ": " + s + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw E.name = "Invariant Violation", E;
                }
                d = t[h](i, h, c, s, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (C) {
                d = C;
              }
              d && !(d instanceof Error) && (W(p), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", c || "React class", s, h, typeof d), W(null)), d instanceof Error && !(d.message in pe) && (pe[d.message] = !0, W(p), y("Failed %s type: %s", s, d.message), W(null));
            }
        }
      }
      var M = L.ReactCurrentOwner, K = Object.prototype.hasOwnProperty, Xe = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, ge, be, G;
      G = {};
      function Ze(t) {
        if (K.call(t, "ref")) {
          var i = Object.getOwnPropertyDescriptor(t, "ref").get;
          if (i && i.isReactWarning)
            return !1;
        }
        return t.ref !== void 0;
      }
      function Qe(t) {
        if (K.call(t, "key")) {
          var i = Object.getOwnPropertyDescriptor(t, "key").get;
          if (i && i.isReactWarning)
            return !1;
        }
        return t.key !== void 0;
      }
      function er(t, i) {
        if (typeof t.ref == "string" && M.current && i && M.current.stateNode !== i) {
          var s = j(M.current.type);
          G[s] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', j(M.current.type), t.ref), G[s] = !0);
        }
      }
      function rr(t, i) {
        {
          var s = function() {
            ge || (ge = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
          };
          s.isReactWarning = !0, Object.defineProperty(t, "key", {
            get: s,
            configurable: !0
          });
        }
      }
      function tr(t, i) {
        {
          var s = function() {
            be || (be = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", i));
          };
          s.isReactWarning = !0, Object.defineProperty(t, "ref", {
            get: s,
            configurable: !0
          });
        }
      }
      var nr = function(t, i, s, c, p, g, h) {
        var d = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: t,
          key: i,
          ref: s,
          props: h,
          // Record the component responsible for creating this element.
          _owner: g
        };
        return d._store = {}, Object.defineProperty(d._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(d, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: c
        }), Object.defineProperty(d, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: p
        }), Object.freeze && (Object.freeze(d.props), Object.freeze(d)), d;
      };
      function ar(t, i, s, c, p) {
        {
          var g, h = {}, d = null, E = null;
          s !== void 0 && (d = "" + s), Qe(i) && (d = "" + i.key), Ze(i) && (E = i.ref, er(i, p));
          for (g in i)
            K.call(i, g) && !Xe.hasOwnProperty(g) && (h[g] = i[g]);
          if (t && t.defaultProps) {
            var C = t.defaultProps;
            for (g in C)
              h[g] === void 0 && (h[g] = C[g]);
          }
          if (d || E) {
            var S = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
            d && rr(h, S), E && tr(h, S);
          }
          return nr(t, d, E, p, c, M.current, h);
        }
      }
      var X = L.ReactCurrentOwner;
      L.ReactDebugCurrentFrame;
      function $(t) {
        k = t;
      }
      var Z;
      Z = !1;
      function Q(t) {
        return typeof t == "object" && t !== null && t.$$typeof === n;
      }
      function me() {
        {
          if (X.current) {
            var t = j(X.current.type);
            if (t)
              return `

Check the render method of \`` + t + "`.";
          }
          return "";
        }
      }
      function ir(t) {
        {
          if (t !== void 0) {
            var i = t.fileName.replace(/^.*[\\\/]/, ""), s = t.lineNumber;
            return `

Check your code at ` + i + ":" + s + ".";
          }
          return "";
        }
      }
      var xe = {};
      function or(t) {
        {
          var i = me();
          if (!i) {
            var s = typeof t == "string" ? t : t.displayName || t.name;
            s && (i = `

Check the top-level render call using <` + s + ">.");
          }
          return i;
        }
      }
      function _e(t, i) {
        {
          if (!t._store || t._store.validated || t.key != null)
            return;
          t._store.validated = !0;
          var s = or(i);
          if (xe[s])
            return;
          xe[s] = !0;
          var c = "";
          t && t._owner && t._owner !== X.current && (c = " It was passed a child from " + j(t._owner.type) + "."), $(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, c), $(null);
        }
      }
      function Re(t, i) {
        {
          if (typeof t != "object")
            return;
          if (Array.isArray(t))
            for (var s = 0; s < t.length; s++) {
              var c = t[s];
              Q(c) && _e(c, i);
            }
          else if (Q(t))
            t._store && (t._store.validated = !0);
          else if (t) {
            var p = He(t);
            if (typeof p == "function" && p !== t.entries)
              for (var g = p.call(t), h; !(h = g.next()).done; )
                Q(h.value) && _e(h.value, i);
          }
        }
      }
      function sr(t) {
        {
          var i = t.type;
          if (i == null || typeof i == "string")
            return;
          var s;
          if (typeof i == "function")
            s = i.propTypes;
          else if (typeof i == "object" && (i.$$typeof === v || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          i.$$typeof === w))
            s = i.propTypes;
          else
            return;
          if (s) {
            var c = j(i);
            Ge(s, t.props, "prop", c, t);
          } else if (i.PropTypes !== void 0 && !Z) {
            Z = !0;
            var p = j(i);
            y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", p || "Unknown");
          }
          typeof i.getDefaultProps == "function" && !i.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function ur(t) {
        {
          for (var i = Object.keys(t.props), s = 0; s < i.length; s++) {
            var c = i[s];
            if (c !== "children" && c !== "key") {
              $(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", c), $(null);
              break;
            }
          }
          t.ref !== null && ($(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), $(null));
        }
      }
      function Ee(t, i, s, c, p, g) {
        {
          var h = Fe(t);
          if (!h) {
            var d = "";
            (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (d += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var E = ir(p);
            E ? d += E : d += me();
            var C;
            t === null ? C = "null" : Array.isArray(t) ? C = "array" : t !== void 0 && t.$$typeof === n ? (C = "<" + (j(t.type) || "Unknown") + " />", d = " Did you accidentally export a JSX literal instead of a component?") : C = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", C, d);
          }
          var S = ar(t, i, s, p, g);
          if (S == null)
            return S;
          if (h) {
            var D = i.children;
            if (D !== void 0)
              if (c)
                if (Array.isArray(D)) {
                  for (var ee = 0; ee < D.length; ee++)
                    Re(D[ee], t);
                  Object.freeze && Object.freeze(D);
                } else
                  y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Re(D, t);
          }
          return t === e.Fragment ? ur(S) : sr(S), S;
        }
      }
      function fr(t, i, s) {
        return Ee(t, i, s, !0);
      }
      function lr(t, i, s) {
        return Ee(t, i, s, !1);
      }
      var cr = lr, dr = fr;
      e.jsx = cr, e.jsxs = dr;
    }();
  }(re)), re;
}
process.env.NODE_ENV === "production" ? se.exports = pr() : se.exports = gr();
var m = se.exports;
function ke(e) {
  var r, n, a = "";
  if (typeof e == "string" || typeof e == "number")
    a += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (r = 0; r < e.length; r++)
        e[r] && (n = ke(e[r])) && (a && (a += " "), a += n);
    else
      for (r in e)
        e[r] && (a && (a += " "), a += r);
  return a;
}
function V() {
  for (var e, r, n = 0, a = ""; n < arguments.length; )
    (e = arguments[n++]) && (r = ke(e)) && (a && (a += " "), a += r);
  return a;
}
var br = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, P = function(e) {
  return typeof e == "string" ? e.length > 0 : typeof e == "number";
}, x = function(e, r, n) {
  return r === void 0 && (r = 0), n === void 0 && (n = Math.pow(10, r)), Math.round(n * e) / n + 0;
}, O = function(e, r, n) {
  return r === void 0 && (r = 0), n === void 0 && (n = 1), e > n ? n : e > r ? e : r;
}, $e = function(e) {
  return (e = isFinite(e) ? e % 360 : 0) > 0 ? e : e + 360;
}, je = function(e) {
  return { r: O(e.r, 0, 255), g: O(e.g, 0, 255), b: O(e.b, 0, 255), a: O(e.a) };
}, te = function(e) {
  return { r: x(e.r), g: x(e.g), b: x(e.b), a: x(e.a, 3) };
}, mr = /^#([0-9a-f]{3,8})$/i, H = function(e) {
  var r = e.toString(16);
  return r.length < 2 ? "0" + r : r;
}, De = function(e) {
  var r = e.r, n = e.g, a = e.b, o = e.a, u = Math.max(r, n, a), f = u - Math.min(r, n, a), l = f ? u === r ? (n - a) / f : u === n ? 2 + (a - r) / f : 4 + (r - n) / f : 0;
  return { h: 60 * (l < 0 ? l + 6 : l), s: u ? f / u * 100 : 0, v: u / 255 * 100, a: o };
}, Ue = function(e) {
  var r = e.h, n = e.s, a = e.v, o = e.a;
  r = r / 360 * 6, n /= 100, a /= 100;
  var u = Math.floor(r), f = a * (1 - n), l = a * (1 - (r - u) * n), v = a * (1 - (1 - r + u) * n), _ = u % 6;
  return { r: 255 * [a, l, f, f, v, a][_], g: 255 * [v, a, a, l, f, f][_], b: 255 * [f, f, v, a, a, l][_], a: o };
}, Te = function(e) {
  return { h: $e(e.h), s: O(e.s, 0, 100), l: O(e.l, 0, 100), a: O(e.a) };
}, Oe = function(e) {
  return { h: x(e.h), s: x(e.s), l: x(e.l), a: x(e.a, 3) };
}, Ce = function(e) {
  return Ue((n = (r = e).s, { h: r.h, s: (n *= ((a = r.l) < 50 ? a : 100 - a) / 100) > 0 ? 2 * n / (a + n) * 100 : 0, v: a + n, a: r.a }));
  var r, n, a;
}, Y = function(e) {
  return { h: (r = De(e)).h, s: (o = (200 - (n = r.s)) * (a = r.v) / 100) > 0 && o < 200 ? n * a / 100 / (o <= 100 ? o : 200 - o) * 100 : 0, l: o / 2, a: r.a };
  var r, n, a, o;
}, xr = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, _r = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Rr = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, Er = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, ue = { string: [[function(e) {
  var r = mr.exec(e);
  return r ? (e = r[1]).length <= 4 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? x(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : e.length === 6 || e.length === 8 ? { r: parseInt(e.substr(0, 2), 16), g: parseInt(e.substr(2, 2), 16), b: parseInt(e.substr(4, 2), 16), a: e.length === 8 ? x(parseInt(e.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(e) {
  var r = Rr.exec(e) || Er.exec(e);
  return r ? r[2] !== r[4] || r[4] !== r[6] ? null : je({ r: Number(r[1]) / (r[2] ? 100 / 255 : 1), g: Number(r[3]) / (r[4] ? 100 / 255 : 1), b: Number(r[5]) / (r[6] ? 100 / 255 : 1), a: r[7] === void 0 ? 1 : Number(r[7]) / (r[8] ? 100 : 1) }) : null;
}, "rgb"], [function(e) {
  var r = xr.exec(e) || _r.exec(e);
  if (!r)
    return null;
  var n, a, o = Te({ h: (n = r[1], a = r[2], a === void 0 && (a = "deg"), Number(n) * (br[a] || 1)), s: Number(r[3]), l: Number(r[4]), a: r[5] === void 0 ? 1 : Number(r[5]) / (r[6] ? 100 : 1) });
  return Ce(o);
}, "hsl"]], object: [[function(e) {
  var r = e.r, n = e.g, a = e.b, o = e.a, u = o === void 0 ? 1 : o;
  return P(r) && P(n) && P(a) ? je({ r: Number(r), g: Number(n), b: Number(a), a: Number(u) }) : null;
}, "rgb"], [function(e) {
  var r = e.h, n = e.s, a = e.l, o = e.a, u = o === void 0 ? 1 : o;
  if (!P(r) || !P(n) || !P(a))
    return null;
  var f = Te({ h: Number(r), s: Number(n), l: Number(a), a: Number(u) });
  return Ce(f);
}, "hsl"], [function(e) {
  var r = e.h, n = e.s, a = e.v, o = e.a, u = o === void 0 ? 1 : o;
  if (!P(r) || !P(n) || !P(a))
    return null;
  var f = function(l) {
    return { h: $e(l.h), s: O(l.s, 0, 100), v: O(l.v, 0, 100), a: O(l.a) };
  }({ h: Number(r), s: Number(n), v: Number(a), a: Number(u) });
  return Ue(f);
}, "hsv"]] }, Pe = function(e, r) {
  for (var n = 0; n < r.length; n++) {
    var a = r[n][0](e);
    if (a)
      return [a, r[n][1]];
  }
  return [null, void 0];
}, yr = function(e) {
  return typeof e == "string" ? Pe(e.trim(), ue.string) : typeof e == "object" && e !== null ? Pe(e, ue.object) : [null, void 0];
}, ne = function(e, r) {
  var n = Y(e);
  return { h: n.h, s: O(n.s + 100 * r, 0, 100), l: n.l, a: n.a };
}, ae = function(e) {
  return (299 * e.r + 587 * e.g + 114 * e.b) / 1e3 / 255;
}, Se = function(e, r) {
  var n = Y(e);
  return { h: n.h, s: n.s, l: O(n.l + 100 * r, 0, 100), a: n.a };
}, fe = function() {
  function e(r) {
    this.parsed = yr(r)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return e.prototype.isValid = function() {
    return this.parsed !== null;
  }, e.prototype.brightness = function() {
    return x(ae(this.rgba), 2);
  }, e.prototype.isDark = function() {
    return ae(this.rgba) < 0.5;
  }, e.prototype.isLight = function() {
    return ae(this.rgba) >= 0.5;
  }, e.prototype.toHex = function() {
    return r = te(this.rgba), n = r.r, a = r.g, o = r.b, f = (u = r.a) < 1 ? H(x(255 * u)) : "", "#" + H(n) + H(a) + H(o) + f;
    var r, n, a, o, u, f;
  }, e.prototype.toRgb = function() {
    return te(this.rgba);
  }, e.prototype.toRgbString = function() {
    return r = te(this.rgba), n = r.r, a = r.g, o = r.b, (u = r.a) < 1 ? "rgba(" + n + ", " + a + ", " + o + ", " + u + ")" : "rgb(" + n + ", " + a + ", " + o + ")";
    var r, n, a, o, u;
  }, e.prototype.toHsl = function() {
    return Oe(Y(this.rgba));
  }, e.prototype.toHslString = function() {
    return r = Oe(Y(this.rgba)), n = r.h, a = r.s, o = r.l, (u = r.a) < 1 ? "hsla(" + n + ", " + a + "%, " + o + "%, " + u + ")" : "hsl(" + n + ", " + a + "%, " + o + "%)";
    var r, n, a, o, u;
  }, e.prototype.toHsv = function() {
    return r = De(this.rgba), { h: x(r.h), s: x(r.s), v: x(r.v), a: x(r.a, 3) };
    var r;
  }, e.prototype.invert = function() {
    return T({ r: 255 - (r = this.rgba).r, g: 255 - r.g, b: 255 - r.b, a: r.a });
    var r;
  }, e.prototype.saturate = function(r) {
    return r === void 0 && (r = 0.1), T(ne(this.rgba, r));
  }, e.prototype.desaturate = function(r) {
    return r === void 0 && (r = 0.1), T(ne(this.rgba, -r));
  }, e.prototype.grayscale = function() {
    return T(ne(this.rgba, -1));
  }, e.prototype.lighten = function(r) {
    return r === void 0 && (r = 0.1), T(Se(this.rgba, r));
  }, e.prototype.darken = function(r) {
    return r === void 0 && (r = 0.1), T(Se(this.rgba, -r));
  }, e.prototype.rotate = function(r) {
    return r === void 0 && (r = 15), this.hue(this.hue() + r);
  }, e.prototype.alpha = function(r) {
    return typeof r == "number" ? T({ r: (n = this.rgba).r, g: n.g, b: n.b, a: r }) : x(this.rgba.a, 3);
    var n;
  }, e.prototype.hue = function(r) {
    var n = Y(this.rgba);
    return typeof r == "number" ? T({ h: r, s: n.s, l: n.l, a: n.a }) : x(n.h);
  }, e.prototype.isEqual = function(r) {
    return this.toHex() === T(r).toHex();
  }, e;
}(), T = function(e) {
  return e instanceof fe ? e : new fe(e);
}, Ae = [], wr = function(e) {
  e.forEach(function(r) {
    Ae.indexOf(r) < 0 && (r(fe, ue), Ae.push(r));
  });
}, ie = function(e) {
  var r = e / 255;
  return r < 0.04045 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
}, oe = function(e) {
  return 0.2126 * ie(e.r) + 0.7152 * ie(e.g) + 0.0722 * ie(e.b);
};
function jr(e) {
  e.prototype.luminance = function() {
    return r = oe(this.rgba), (n = 2) === void 0 && (n = 0), a === void 0 && (a = Math.pow(10, n)), Math.round(a * r) / a + 0;
    var r, n, a;
  }, e.prototype.contrast = function(r) {
    r === void 0 && (r = "#FFF");
    var n, a, o, u, f, l, v, _ = r instanceof e ? r : new e(r);
    return u = this.rgba, f = _.toRgb(), l = oe(u), v = oe(f), n = l > v ? (l + 0.05) / (v + 0.05) : (v + 0.05) / (l + 0.05), (a = 2) === void 0 && (a = 0), o === void 0 && (o = Math.pow(10, a)), Math.floor(o * n) / o + 0;
  }, e.prototype.isReadable = function(r, n) {
    return r === void 0 && (r = "#FFF"), n === void 0 && (n = {}), this.contrast(r) >= (l = (f = (a = n).size) === void 0 ? "normal" : f, (u = (o = a.level) === void 0 ? "AA" : o) === "AAA" && l === "normal" ? 7 : u === "AA" && l === "large" ? 3 : 4.5);
    var a, o, u, f, l;
  };
}
wr([jr]);
var z = {};
Object.defineProperty(z, "__esModule", { value: !0 });
var Le = z.fastHashCode = void 0;
function Me(e, r = {}) {
  const { forcePositive: n = !1, caseSensitive: a = !0, seed: o = 0 } = r;
  a || (e = e.toLowerCase());
  let u = o, f;
  for (f = 0; f < e.length; f++)
    u = (u << 5) - u + e.charCodeAt(f), u |= 0;
  return n && (u = u & 2147483647), u;
}
Le = z.fastHashCode = Me;
z.default = Me;
const Tr = (e) => {
  var v, _;
  if (!e)
    return "U";
  const r = /[\s-']/g, n = /[\w\p{L}]+/gu, o = e.split(r).filter(
    (R) => R.match(n)
  ), u = ((v = o.shift()) == null ? void 0 : v.charAt(0)) ?? "", f = ((_ = o.pop()) == null ? void 0 : _.charAt(0)) ?? "";
  return (u + f).toUpperCase();
}, Or = (e) => {
  if (!e)
    return "hsl(229, 84%, 60%)";
  let a = `hsl(${Le(e, { forcePositive: !0 }) % 360}, 66%, 45%)`;
  for (; !T("#fff").isReadable(a); )
    a = T(a).darken(0.1).toHslString();
  return a;
}, Cr = {
  2: "h-2 w-2 border-2",
  "3.5": "h-3.5 w-3.5 border-3",
  5: "h-5 w-5 border-4"
}, Ye = ({
  idleColor: e,
  onlineColor: r,
  size: n = "3.5",
  status: a
}) => {
  const o = B(() => {
    const v = a === "idle" ? e : r;
    return v && T(v).isValid() ? v : void 0;
  }, [e, r, a]), u = B(() => o ? { backgroundColor: o } : void 0, [o]), f = !!o, l = a === "idle" ? "bg-amber-500" : "bg-green-500";
  return /* @__PURE__ */ m.jsx(
    "div",
    {
      className: V(
        "rounded-full border-solid content-none border-tertiary",
        Cr[n],
        { [l]: !f }
      ),
      "data-testid": "status-indicator-element",
      style: u
    }
  );
};
Ye.displayName = "StatusIndicator";
const F = "rounded-md", q = "rounded-lg", Ne = {
  5: "w-5 h-5",
  6: "w-6 h-6",
  7: "w-7 h-7",
  8: "w-8 h-8",
  9: "w-9 h-9",
  10: "w-10 h-10",
  14: "w-14 h-14",
  16: "w-16 h-16",
  24: "w-24 h-24"
}, Pr = {
  5: "text-xxs",
  6: "text-xs",
  7: "text-xs",
  8: "text-sm",
  9: "text-base",
  10: "text-base",
  14: "text-base",
  16: "text-xl",
  24: "text-4xl"
}, Sr = {
  5: "rounded-3px",
  6: "rounded-4px",
  7: "rounded-4px",
  8: "rounded-5px",
  9: F,
  10: F,
  14: q,
  16: q,
  24: "rounded-xl"
}, Ar = {
  5: "rounded-5px",
  6: F,
  7: F,
  8: "rounded-7px",
  9: q,
  10: q,
  14: "rounded-10px",
  16: "rounded-10px",
  24: "rounded-14px"
}, N = ({
  hasBorder: e = !1,
  isFullRounded: r = !1,
  name: n,
  size: a = "6",
  src: o
}) => {
  const u = !!o, [f, l] = vr(!1), v = hr(() => {
    l(!0);
  }, []), _ = B(() => Tr(n), [n]), R = B(
    () => ({ backgroundColor: Or(n) }),
    [n]
  ), w = u && !f;
  return /* @__PURE__ */ m.jsxs(
    "div",
    {
      className: V(
        "relative inline-flex h-fit w-fit shrink-0 grow-0 overflow-hidden",
        {
          [Sr[a]]: !e && !r,
          [Ar[a]]: e && !r,
          "border-2 border-inherit": e,
          "rounded-full": r
        }
      ),
      "data-testid": "user-image-container",
      children: [
        w && /* @__PURE__ */ m.jsx(
          "img",
          {
            alt: "",
            className: V(
              "absolute left-0 top-0 select-none object-cover",
              Ne[a]
            ),
            "data-testid": "user-image-element",
            src: o,
            onError: v
          }
        ),
        /* @__PURE__ */ m.jsx(
          "div",
          {
            "aria-hidden": "true",
            className: V(
              "flex select-none items-center justify-center font-medium text-white",
              Ne[a],
              Pr[a],
              {
                invisible: w
              }
            ),
            "data-testid": "user-image-initials",
            style: R,
            children: _
          }
        )
      ]
    }
  );
};
N.displayName = "UserImage";
const Nr = ({
  isFullRounded: e = !1,
  size: r = "7",
  users: n
}) => {
  if (n.length === 0)
    return null;
  const [a, o, u] = n;
  return /* @__PURE__ */ m.jsxs(
    "div",
    {
      className: "inline-flex flex-row-reverse border-inherit",
      "data-testid": "three-user-row",
      children: [
        u && /* @__PURE__ */ m.jsx(
          "div",
          {
            className: "-ml-1 inline-flex border-inherit",
            "data-testid": "user-row",
            children: /* @__PURE__ */ m.jsx(
              N,
              {
                hasBorder: !0,
                isFullRounded: e,
                name: u.name,
                size: r,
                src: u.src
              }
            )
          }
        ),
        o && /* @__PURE__ */ m.jsx(
          "div",
          {
            className: "-ml-1 inline-flex border-inherit",
            "data-testid": "user-row",
            children: /* @__PURE__ */ m.jsx(
              N,
              {
                hasBorder: !0,
                isFullRounded: e,
                name: o.name,
                size: r,
                src: o.src
              }
            )
          }
        ),
        a && /* @__PURE__ */ m.jsx("div", { className: "inline-flex border-inherit", "data-testid": "user-row", children: /* @__PURE__ */ m.jsx(
          N,
          {
            hasBorder: !0,
            isFullRounded: e,
            name: a.name,
            size: r,
            src: a.src
          }
        ) })
      ]
    }
  );
};
Nr.displayName = "ThreeUserRow";
const Ir = ({
  isFullRounded: e = !1,
  users: r
}) => {
  const [n, a] = r;
  return /* @__PURE__ */ m.jsxs("div", { className: "inline-flex flex-col border-inherit", children: [
    /* @__PURE__ */ m.jsx("div", { className: "flex border-inherit", children: /* @__PURE__ */ m.jsx(
      N,
      {
        hasBorder: !0,
        isFullRounded: e,
        name: n.name,
        size: "6",
        src: n.src
      }
    ) }),
    /* @__PURE__ */ m.jsx("div", { className: "-mt-5 ml-2 flex border-inherit", children: /* @__PURE__ */ m.jsx(
      N,
      {
        hasBorder: !0,
        isFullRounded: e,
        name: a.name,
        size: "6",
        src: a.src
      }
    ) })
  ] });
};
Ir.displayName = "TwoUserStack";
const kr = (e) => !!e && typeof e == "string" && (e === "online" || e === "idle" || e === "offline"), $r = {
  5: "2",
  6: "2",
  7: "3.5",
  8: "3.5",
  9: "3.5",
  10: "3.5",
  14: "3.5",
  16: "5",
  24: "5"
}, Dr = ({
  idleColor: e,
  isFullRounded: r,
  name: n,
  onlineColor: a,
  size: o = "8",
  src: u,
  status: f
}) => /* @__PURE__ */ m.jsxs(
  "div",
  {
    className: "relative inline-flex flex-col",
    "data-testid": "user-image-status-element",
    children: [
      /* @__PURE__ */ m.jsx(
        N,
        {
          isFullRounded: r,
          name: n,
          size: o,
          src: u
        }
      ),
      kr(f) && f !== "offline" && /* @__PURE__ */ m.jsx(
        "div",
        {
          className: "absolute bottom-1 right-1 translate-x-1/2 translate-y-1/2",
          "data-testid": "status-indicator-container",
          children: /* @__PURE__ */ m.jsx(
            Ye,
            {
              idleColor: e,
              onlineColor: a,
              size: $r[o],
              status: f
            }
          )
        }
      )
    ]
  }
);
Dr.displayName = "UserImageStatus";
export {
  Ye as StatusIndicator,
  Nr as ThreeUserRow,
  Ir as TwoUserStack,
  N as UserImage,
  Dr as UserImageStatus,
  kr as hasUserStatus,
  Or as nameToHslColor,
  Tr as nameToInitials
};
